import {Constants} from "../../Constants/Constant";
import store from '../../store';

let s = Constants.internalStatus
let lrPerformaOrderStatuses = [s.pendingForApproval, s.pendingForOrderConfirmation, s.orderNotReady, s.underPickupProcess,
                               s.readyForPickup, s.tempoOnTheWayToPickupLoad, s.tempoWaitingForLoadingMaterial, s.underBillingProcess,
                               s.onTheWayToPickupCityWarehouse, s.underVerificationAtPickupCityWarehouse, s.inProcessOfDeparture, s.waitingForDeparture]
let lrFinalOrderStatuses = [s.onTheWayToDropCityWarehouse, s.atDestinationCityWarehouse, s.readyForFinalDelivery, s.completed]
let lrCancelOrderStatuses = [s.cancel, s.rejected]

export function getLRStatus(lr, order){
  if(lr.status==='ACTIVE' && lrPerformaOrderStatuses.includes(order.internalstatus)){
    return 'Performa'
  }else if(lr.status==='ACTIVE' && lrFinalOrderStatuses.includes(order.internalstatus)){
    return 'Final'
  }else if(lr.status==='INACTIVE' || lrCancelOrderStatuses.includes(order.internalstatus)){
    return 'Canceled'
  }
}

export const lrStatusColor = {
  'Performa': '#f6b26b',
  'Final': '#6aa84f',
  'Canceled': '#ff0000',
}

export function isLREditable(lr, order){
  let roleId = store.state.userObj.role[0].id
  let status = getLRStatus(lr, order)
  if(roleId === Constants.adminRoleId || ['Performa'].includes(status)) return true
}

export function getVehicleDetails(order, type, returnKey){
  if(type === 'LOCAL VEHICLE'){
    if(returnKey === 'platNo') return order.orderDetails.PIckupTempo?.tempo['platNo'] || order.orderDetails.PickupTruck?.truck['platNo']
    else if(returnKey === 'driverName') return  order.orderDetails.PIckupTempo?.driverDetail['name'] || order.orderDetails.PickupTruck?.driverDetail['name']
    else if(returnKey === 'driverMobile') return  order.orderDetails.PIckupTempo?.driverDetail['mobile'] || order.orderDetails.PickupTruck?.driverDetail['mobile']
  }else if(type === 'TRANSPORT VEHICLE'){
    if(returnKey === 'platNo') return  order.orderDetails.truckOrder?.truck['platNo']
    else if(returnKey === 'driverName') return  order.orderDetails.truckOrder?.driverDetail['name']
    else if(returnKey === 'driverMobile') return  order.orderDetails.truckOrder?.driverDetail['mobile']
  }
  return ''
}

export function hotSettingsExcelLR(colWidths = [], self){
  let hotSettings = {
    data: null,
    readOnly: true,
    fillHandle: false,
    copyPaste: false,
    licenseKey: "non-commercial-and-evaluation",
    autoRowSize: false,
    autoColumnSize: false,
    colWidths: colWidths,
    className: "htCenter htMiddle",
    filters: true,
    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
    columnSorting: { sortEmptyCells: true },
    afterSelectionEnd: (row, column, row2, column2, selectionLayerLevel) => {
      self.afterSelection();
    },
    outsideClickDeselects: function(event) {
      // console.log('event', event)
      let id = event.parentNode.id || event.id;
      if(['print-btn', 'cancel-btn', 'close-btn'].includes(id)) return false;
      else { self.resetSelection(); return true; }
    }
  }
  return hotSettings
}

export function getAllNumbersBetween(x, y) {
  let numbers = [], a=x, b=y;
  if(x > y) { a=y; b=x; }
  for (let i = a; i <= b; i++) {
    numbers.push(i);
  }
  return numbers;
}
